export default "__VITE_ASSET__DQq0oAOk__"